(() => {
  const ukFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const ukPartsFor = (date) => Object.fromEntries(
    ukFormatter.formatToParts(date).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)])
  );
  const ukLocalToInstant = (year, month, day, hour) => {
    const guess = new Date(Date.UTC(year, month - 1, day, hour));
    const rendered = ukPartsFor(guess);
    const renderedAsUtc = Date.UTC(rendered.year, rendered.month - 1, rendered.day, rendered.hour, rendered.minute, rendered.second);
    return new Date(guess.getTime() - (renderedAsUtc - guess.getTime()));
  };
  const nextBusinessCutoff = (now) => {
    const current = ukPartsFor(now);
    let cursor = new Date(Date.UTC(current.year, current.month - 1, current.day));
    let cutoff = ukLocalToInstant(current.year, current.month, current.day, 15);
    if (cursor.getUTCDay() === 0 || cursor.getUTCDay() === 6 || now >= cutoff) {
      do { cursor.setUTCDate(cursor.getUTCDate() + 1); }
      while (cursor.getUTCDay() === 0 || cursor.getUTCDay() === 6);
      cutoff = ukLocalToInstant(cursor.getUTCFullYear(), cursor.getUTCMonth() + 1, cursor.getUTCDate(), 15);
    }
    return cutoff;
  };

  const updateCountdowns = () => {
    const now = new Date();
    const cutoff = nextBusinessCutoff(now);
    const seconds = Math.max(0, Math.floor((cutoff.getTime() - now.getTime()) / 1000));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    document.querySelectorAll('[data-dispatch-countdown] strong').forEach((element) => {
      element.textContent = `${hours}h ${minutes}m ${remainingSeconds}s`;
    });
    document.querySelectorAll('[data-dispatch-label]').forEach((element) => {
      const today = ukPartsFor(now);
      const cutoffDay = ukPartsFor(cutoff);
      const isToday = today.year === cutoffDay.year && today.month === cutoffDay.month && today.day === cutoffDay.day;
      const dispatchDay = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'long' }).format(cutoff);
      element.textContent = isToday ? 'for same-day dispatch.' : `for ${dispatchDay} dispatch.`;
    });
  };

  document.querySelectorAll('[data-collection-product]').forEach((module) => {
    const idInput = module.querySelector('[data-variant-id]');
    const stock = module.querySelector('[data-product-stock]');
    const price = module.querySelector('[data-product-price]');
    const submit = module.querySelector('[data-add-to-cart]');
    const cardForChoice = (choice) => choice?.closest('.collection-highlight__bundle')
      || (choice?.id ? module.querySelector(`label[for="${choice.id}"]`) : null);
    const choiceForModeCard = (card) => card.querySelector('[data-variant-choice]')
      || (card.htmlFor ? module.querySelector(`#${card.htmlFor}`) : null);

    module.querySelectorAll('[data-variant-choice]').forEach((choice) => {
      choice.addEventListener('change', () => {
        if (!choice.checked) return;
        idInput.value = choice.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        module.querySelectorAll('.collection-highlight__bundle').forEach((card) => card.classList.remove('is-selected'));
        cardForChoice(choice)?.classList.add('is-selected');
        const available = choice.dataset.available === 'true';
        stock.lastChild.textContent = available ? 'In stock' : 'Out of stock';
        stock.classList.toggle('is-unavailable', !available);
        price.innerHTML = `${choice.dataset.comparePrice ? `<s>${choice.dataset.comparePrice}</s>` : ''}<strong>${choice.dataset.price}</strong>${choice.dataset.comparePrice ? '<span>Sale</span>' : ''}`;
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
      });
    });

    const coupleToggle = module.querySelector('[data-couple-toggle]');
    if (coupleToggle) {
      const updateCoupleMode = () => {
        const visibleChoices = [];
        module.querySelectorAll('[data-couple-variant]').forEach((card) => {
          card.hidden = (card.dataset.coupleVariant === 'true') !== coupleToggle.checked;
          if (!card.hidden) visibleChoices.push(choiceForModeCard(card));
        });
        const currentChoice = module.querySelector('[data-variant-choice]:checked');
        const currentModeCard = currentChoice?.closest('[data-couple-variant]') || cardForChoice(currentChoice);
        if (!currentChoice || currentModeCard?.hidden) {
          const nextChoice = visibleChoices.find((choice) => choice && !choice.disabled);
          if (nextChoice) {
            nextChoice.checked = true;
            nextChoice.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
      coupleToggle.addEventListener('change', updateCoupleMode);
      updateCoupleMode();
    }

    const coupleModeButtons = module.querySelectorAll('[data-couple-mode]');
    if (coupleModeButtons.length) {
      const updateCardMode = (mode) => {
        const visibleChoices = [];
        coupleModeButtons.forEach((button) => {
          const active = button.dataset.coupleMode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        module.querySelectorAll('[data-couple-variant]').forEach((card) => {
          const cardMode = card.dataset.coupleVariant === 'true' ? 'couple' : 'single';
          card.hidden = cardMode !== mode;
          if (!card.hidden) visibleChoices.push(choiceForModeCard(card));
        });
        const currentChoice = module.querySelector('[data-variant-choice]:checked');
        const currentModeCard = currentChoice?.closest('[data-couple-variant]') || cardForChoice(currentChoice);
        if (!currentChoice || currentModeCard?.hidden) {
          const nextChoice = visibleChoices.find((choice) => choice && !choice.disabled);
          if (nextChoice) {
            nextChoice.checked = true;
            nextChoice.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
      coupleModeButtons.forEach((button) => button.addEventListener('click', () => {
        updateCardMode(button.dataset.coupleMode);
        const hint = module.querySelector('[data-bundle-hint]');
        if (hint) hint.innerHTML = button.dataset.coupleMode === 'couple'
          ? '<strong>Couples pack selected.</strong> Two kits, packed together for convenience.'
          : '<strong>Testing with a partner?</strong> Switch to a couples pack and save.';
      }));
      updateCardMode('single');
    }

    const quantity = module.querySelector('input[name="quantity"]');
    module.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    module.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });
  });

  updateCountdowns();
  window.setInterval(updateCountdowns, 1000);
})();
